import React, { ReactNode } from 'react';
import {
  DataRouteMatch, useParams,
} from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

export interface Params {
  healthDeclarationId: string;
}

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export interface ProtectedRouteProps {
  computedMatch?: DataRouteMatch;
  path?: string;
  children: ReactNode;
}

const ProtectedRoute = (props: ProtectedRouteProps): React.ReactElement => {
  const {
    children,
  } = props;
  const { healthDeclarationId } = useParams();
  const { keycloak } = useKeycloak();

  if (keycloak && !keycloak.authenticated) {
    void keycloak.login({
      loginHint: healthDeclarationId,
    });
  } else if (keycloak) {
    keycloak.loadUserProfile()
      .then((profile: Keycloak.KeycloakProfile) => {
        if (profile.username === healthDeclarationId) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          return children;
        }

        void keycloak.logout();
        return undefined;
      })
      .catch((err: Error) => {
        if (err) throw new Error(err.message);
      });
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return children;
};

export default ProtectedRoute;
